import { Reveal } from "@/components/Reveal";
import { SectionParticles } from "@/components/SectionParticles";
import { SectionBg } from "@/components/SectionBg";
import { RegistrationForm } from "@/components/RegistrationForm";

const TRUST_BULLETS = [
  "Free live educational workshop",
  "No loan application required to attend",
  "No hard credit pull required to attend",
  "No obligation to request an individual review",
];

/* SECTION 12 — FINAL REGISTRATION */
export const FinalRegister = () => (
  <section
    id="register"
    className="relative px-5 md:px-10 lg:px-16 py-28 md:py-40 overflow-hidden"
    style={{ background: "var(--background-deep)" }}
    data-testid="final-register-section"
  >
    <SectionBg img="bg-home-6.jpg" strength={0.93} />
    {/* subtle grid */}
    <div
      aria-hidden="true"
      className="absolute inset-0 opacity-[0.05]"
      style={{
        backgroundImage:
          "linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)",
        backgroundSize: "72px 72px",
      }}
    />
    {/* one accent radial glow */}
    <div
      aria-hidden="true"
      className="absolute inset-0 pointer-events-none"
      style={{ background: "radial-gradient(ellipse 60% 45% at 30% 40%, rgba(148,222,82,0.09), transparent)" }}
    />
    <SectionParticles variant="houses" />
    <div className="relative z-10 max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center text-left">
      <div>
        <p className="font-mono text-[11px] tracking-[0.3em] text-[var(--muted)] mb-10">
          [009] — RESERVE YOUR PLACE
        </p>
        <Reveal>
          <h2 className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl leading-tight text-white mb-10">
            YOUR NEXT MOVE STARTS WITH A CLEARER BENEFIT MAP.
          </h2>
        </Reveal>
        <ul className="space-y-4">
          {TRUST_BULLETS.map((b, i) => (
            <Reveal key={b} delay={i * 0.08}>
              <li className="flex items-start gap-3 text-sm md:text-base text-[rgba(255,255,255,0.82)]" data-testid={`trust-bullet-${i}`}>
                <span aria-hidden="true" className="text-[var(--accent)]">✓</span>
                {b}
              </li>
            </Reveal>
          ))}
        </ul>
      </div>
      <Reveal>
        <RegistrationForm prefix="final-form" showBonuses />
      </Reveal>
    </div>
  </section>
);
